














































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { FeedbackCategorie } from '@/model/pleased';
import { sendToParrent } from '@/common/bridge';
import { GA_EVENT_NAME_ENUM } from '@/common/gaHelper';

@Component
export default class ChatRating extends Vue {
  $refs!: {
    index: HTMLDivElement
  }
  @Prop({ default: [] }) readonly feedbackCategories!: FeedbackCategorie[];
  @Prop({ default: 'chat' }) readonly mode!: 'chat' | 'voice';

  selectedStar = 0;
  selectedOptionIds: number[] = [];
  comment = '';
  isFinish = false;

  created () {
    this.$gtag.event(GA_EVENT_NAME_ENUM.CHAT_RATING_SHOW);
  }

  handleSelectStar (i: number) {
    if (this.isFinish) return;
    this.selectedStar = i;

    this.$emit('send:feedback', {
      rating: this.selectedStar,
      comment: this.comment,
      feedbackSelectionIds: this.selectedStar < 4 ? this.selectedOptionIds : [],
      type: this.mode,
    });
  }
  toggleOption (id: number) {
    if (this.isFinish) return;
    const index = this.selectedOptionIds.indexOf(id);
    if (index !== -1) {
      this.selectedOptionIds.splice(index, 1);
    } else {
      this.selectedOptionIds.push(id);
    }
  }
  skip () {
    this.$gtag.event(GA_EVENT_NAME_ENUM.CHAT_RATING_SKIP);
    sendToParrent('CLEAR_FLOAT');
    sendToParrent('CLOSE');
  }
  handleSubmit () {
    this.$gtag.event(GA_EVENT_NAME_ENUM.CHAT_RATING_SUBMIT);
    this.$emit('submit', {
      rating: this.selectedStar,
      comment: this.comment,
      feedbackSelectionIds: this.selectedStar < 4 ? this.selectedOptionIds : [],
      type: this.mode,
    });
    this.isFinish = true;
  }
}
